import React from 'react'
import { useTranslation } from 'react-i18next'

import styles from './SponsorAdMessage.module.scss'
import Icon from '../icon'

export default function SponsorAdMessage({
  adMessage,
  business,
  variant = undefined,
}) {
  const { t } = useTranslation()
  const isChampion = variant === 'champion'
  const profileLabel = t('business.sponsor_ad_message.preview.profile')
  const profilePath =
    business?.slug != null || business?.id != null
      ? `/profile/business/${encodeURIComponent(business.slug ?? business.id)}`
      : null

  return (
    <div
      className={
        isChampion ? `${styles.container} ${styles.champion}` : styles.container
      }
    >
      <div className={styles.logo}>
        <img
          alt="Avatar"
          className="rounded-circle avatar-border bg-white"
          src={
            business?.media_attachment?.direct_upload_url ||
            '/images/default-business.png'
          }
        />
      </div>
      <div className={styles.content}>
        <div className={styles.messageContent}>
          <span className={styles.name}>{business?.name}</span>
          <span className={styles.message}>
            &nbsp;-&nbsp;
            {adMessage?.length ? adMessage : business?.pay_forward_message}
          </span>
        </div>
        <div className={styles.footer}>
          <span className={styles.ref}>
            {isChampion
              ? t('business.sponsor_ad_message.preview.champion')
              : t('business.sponsor_ad_message.preview.sponsor')}
          </span>
          {profilePath ? (
            <span>
              <a
                href={profilePath}
                target="_blank"
                rel="noopener noreferrer"
                title={`${business?.name} ${profileLabel}`}
              >
                {profileLabel}
                &nbsp;
                <Icon name="external-link-alt" />
              </a>
            </span>
          ) : null}
        </div>
      </div>
    </div>
  )
}
